import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import app from "../firebase";

export default function HomePage() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const heroUrl = "https://firebasestorage.googleapis.com/v0/b/enrollease-19c30.firebasestorage.app/o/0b066868-1af4-4707-92b9-1415dfc9cd69.jfif?alt=media&token=d0997bca-e7bc-4389-a892-3e6a288072bd";

  const portalOptions = [
    { label: "Student Application", route: "/signin" },
    { label: "Enrolled Student", route: "/enrolled/signin" },
    { label: "Academic Administrators", route: "/academics" },
    { label: "Registrar", route: "/registar-login" },
    { label: "Admission", route: "/admission-login" },
    { label: "Room Management", route: "/room-management-login" },
    { label: "System Admin", route: "/admin-login" },
  ];

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      {/* HERO */}
      <header
        style={{
          height: 360,
          backgroundImage: `url(${heroUrl})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          position: "relative",
          color: "#fff"
        }}
      >
        {/* overlay */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(90deg, rgba(0,128,80,0.75) 0%, rgba(6,51,33,0.75) 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "24px",
          }}
        >
          <div style={{ position: "absolute", top: 24, right: 24, zIndex: 10 }}>
            <button
              type="button"
              aria-label="Open portal menu"
              onClick={() => setMenuOpen((open) => !open)}
              style={{
                width: 52,
                height: 52,
                borderRadius: "50%",
                border: "1px solid rgba(255,255,255,0.7)",
                background: "rgba(255,255,255,0.12)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
                backdropFilter: "blur(4px)",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                <span style={{ width: 22, height: 2, background: "#fff", borderRadius: 999 }} />
                <span style={{ width: 22, height: 2, background: "#fff", borderRadius: 999 }} />
                <span style={{ width: 22, height: 2, background: "#fff", borderRadius: 999 }} />
              </div>
            </button>

            {menuOpen && (
              <div
                style={{
                  position: "absolute",
                  top: 62,
                  right: 0,
                  width: 260,
                  background: "#fff",
                  borderRadius: 12,
                  boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
                  padding: 12,
                  zIndex: 20,
                }}
              >
                <div style={{ fontWeight: 800, fontSize: 14, color: "#155c2b", marginBottom: 8, padding: "4px 8px" }}>
                  Select Portal
                </div>
                {portalOptions.map((portal) => (
                  <button
                    key={portal.label}
                    type="button"
                    onClick={() => {
                      setMenuOpen(false);
                      navigate(portal.route);
                    }}
                    style={{
                      width: "100%",
                      textAlign: "left",
                      background: "#f7faf7",
                      border: "1px solid #e9efe9",
                      borderRadius: 8,
                      padding: "10px 12px",
                      marginBottom: 8,
                      fontWeight: 600,
                      color: "#155c2b",
                      cursor: "pointer",
                    }}
                  >
                    {portal.label}
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* CENTERED CONTENT */}
          <div style={{ maxWidth: 980, width: "100%", display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", gap: 8 }}>

            <div style={{ display: "flex", alignItems: "center", gap: 16 }}>

              <div style={{ fontSize: 72, fontWeight: 800, lineHeight: 1, letterSpacing: 1 }}>EnrollEase</div>
            </div>
            <div style={{ fontSize: 18, opacity: 0.95, marginTop: 6 }}>Manila Adventist College</div>
            <div style={{ fontStyle: "italic", fontSize: 14, opacity: 0.9, marginTop: 10, maxWidth: 700 }}>
              "Equipping Students for Life and Preparing Them for Service"
            </div>

            <button 
              onClick={() => navigate("/signin")}
              style={{
                marginTop: 20,
                background: "#ff6f2e",
                color: "#fff",
                border: "none",
                padding: "12px 24px",
                borderRadius: 8,
                cursor: "pointer",
                fontWeight: 700,
              }}
            >
              ONLINE APPLICATION
            </button>
          </div>
        </div>
      </header>

      {/* PORTAL CARDS */}
      <main style={{ background: "#efefef", padding: "48px 24px", flex: 1 }}>
        <div style={{ maxWidth: 1100, margin: "0 auto", display: "flex", gap: 28, justifyContent: "center", alignItems: "stretch" }}>
          <section
            style={{
              background: "#0f5f3b",
              color: "#fff",
              padding: 28,
              borderRadius: 16,
              flex: "1 1 380px",
              boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div>
              <h3 style={{ marginTop: 0 }}>Application Portal</h3>
              <p style={{ color: "#dfeede" }}>
                Online facility for application, admission, and requirements gathering for new students and transferees.
              </p>
            </div>
            <div style={{ marginTop: 12 }}>
              <button
                onClick={() => navigate("/signin")}
                style={{
                  background: "#ff6f2e",
                  color: "#fff",
                  border: "none",
                  padding: "10px 16px",
                  borderRadius: 20,
                  cursor: "pointer",
                  fontWeight: 700,
                }}
              >
                Register
              </button>
            </div>
          </section>

          <section
            style={{
              background: "#0f5f3b",
              color: "#fff",
              padding: 28,
              borderRadius: 16,
              flex: "1 1 380px",
              boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div>
              <h3 style={{ marginTop: 0 }}>Student Portal</h3>
              <p style={{ color: "#dfeede" }}>
                Access relevant resources, collaboration tools, communication updates, and information for enrolled students.
              </p>
            </div>
            <div style={{ marginTop: 12 }}>
              <button
                onClick={() => navigate("/enrolled/signin")}
                style={{
                  background: "#ff6f2e",
                  color: "#fff",
                  border: "none",
                  padding: "10px 16px",
                  borderRadius: 20,
                  cursor: "pointer",
                  fontWeight: 700,
                }}
              >
                Login
              </button>
            </div>
          </section>
        </div>
      </main>

      {/* FOOTER */}
      <footer style={{ background: "#0f5f3b", color: "#dfeede", padding: "28px 24px" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <div style={{ fontWeight: 700, marginBottom: 8 }}>1975 Corner Donada & San Juan St.,</div>
            <div>Pasay City, 1300</div>
            <div style={{ marginTop: 8 }}>Phone: (63 2) 525-9191 to 9198</div>
            <div>Email: info@mac.edu.ph</div>
          </div>
          <div style={{ textAlign: "center" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, justifyContent: "center" }}>

              <div style={{ fontSize: 28, color: "#fff", fontWeight: 800 }}>EnrollEase</div>
            </div>
            <div style={{ marginTop: 6, opacity: 0.9 }}>© Copyright EnrollEase All Rights Reserved</div>
          </div>
        </div>
      </footer>
    </div>
  );
}